export default __webpack_public_path__ + "static/media/Pharmacy.0f081762.png";